<h1 mat-dialog-title>Add New Contact</h1>
<div
  class="flex flex-col justify-start items-stretch"
  [formGroup]="form"
  mat-dialog-content
>
  <div
    class="flex md:flex-row flex-col justify-start items-stretch md:items-center md:gap-x-2"
  >
    <mat-form-field>
      <mat-label>First name</mat-label>
      <input matInput formControlName="first_name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Last name</mat-label>
      <input matInput formControlName="last_name" />
    </mat-form-field>
  </div>
  <mat-form-field class="w-full">
    <mat-label>Notes</mat-label>
    <textarea
      matInput
      [cdkTextareaAutosize]="4"
      formControlName="notes"
    ></textarea>
  </mat-form-field>
  <div
    class="flex-flex-col justify-start items-stretch"
    formArrayName="contact_methods"
  >
    <h2 class="pt-2 pb-3">Contact Methods</h2>
    <div
      *ngFor="
        let contactMethod of form.controls.contact_methods.controls;
        let i = index
      "
      class="flex flex-row justify-start items-center"
    >
      <app-contact-method-control
        [formControlName]="i"
      ></app-contact-method-control>
      @if (i > 0) {
        <button mat-icon-button (click)="removeContactMethod(i)">
          <mat-icon>close_small</mat-icon>
        </button>
      }
    </div>
    <div class="flex flex-row justify-center items-center">
      <button
        mat-stroked-button
        color="primary"
        class="self-center"
        (click)="addContactMethod()"
      >
        Add a contact method
      </button>
    </div>
    <!-- </div> -->
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="null">Cancel</button>
    <button mat-button [disabled]="!form.valid" (click)="submit()">Save</button>
  </div>
</div>
